import { ReactComponent as ChatIcon } from 'assets/icons/chat.svg'
import { Button } from 'components/uikit/button/Button'

const QuestionsBanner = () => {
  if (!process.env.REACT_APP_IA_ASSISTANT_URL?.length) {
    return <></>
  }
  return (
    <div className="flex bg-black p-8 gap-6 rounded-3xl items-center mx-auto w-[1136px] mt-24">
      <ChatIcon className="shrink-0" />
      <strong className="font-bold text-18 leading-7 shrink-0 text-white">Got questions, need guidance?</strong>
      <span className="leading-[22px] text-14 grow text-white">
        Head to CokeGPT and select our NMA Guide to get your answers.
      </span>
      <Button
        className="shrink-0"
        variant="secondary"
        onClick={() => window.open(process.env.REACT_APP_IA_ASSISTANT_URL ?? '')}
        text="CokeGPT"
      />
    </div>
  )
}

export default QuestionsBanner
